/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppActivitiesRouteImport } from './routes/_app/activities'
import { Route as AppAppointmentsRouteImport } from './routes/_app/appointments'
import { Route as AppPaymentsRouteImport } from './routes/_app/payments'
import { Route as AppServicesRouteImport } from './routes/_app/services'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppContactsIndexRouteImport } from './routes/_app/contacts.index'
import { Route as AppContactsContactIdRouteImport } from './routes/_app/contacts.$contactId'
import { Route as AppContactsNewRouteImport } from './routes/_app/contacts.new'
import { Route as AppInvoicesInvoiceIdRouteImport } from './routes/_app/invoices.$invoiceId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppActivitiesRoute = AppActivitiesRouteImport.update({
  id: '/activities',
  path: '/activities',
  getParentRoute: () => AppRoute,
} as any)
const AppAppointmentsRoute = AppAppointmentsRouteImport.update({
  id: '/appointments',
  path: '/appointments',
  getParentRoute: () => AppRoute,
} as any)
const AppPaymentsRoute = AppPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AppRoute,
} as any)
const AppServicesRoute = AppServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsIndexRoute = AppContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsContactIdRoute = AppContactsContactIdRouteImport.update({
  id: '/contacts/$contactId',
  path: '/contacts/$contactId',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsNewRoute = AppContactsNewRouteImport.update({
  id: '/contacts/new',
  path: '/contacts/new',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesInvoiceIdRoute = AppInvoicesInvoiceIdRouteImport.update({
  id: '/invoices/$invoiceId',
  path: '/invoices/$invoiceId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/activities': typeof AppActivitiesRoute
  '/appointments': typeof AppAppointmentsRoute
  '/payments': typeof AppPaymentsRoute
  '/services': typeof AppServicesRoute
  '/settings': typeof AppSettingsRoute
  '/contacts/$contactId': typeof AppContactsContactIdRoute
  '/contacts/new': typeof AppContactsNewRoute
  '/invoices/$invoiceId': typeof AppInvoicesInvoiceIdRoute
  '/contacts/': typeof AppContactsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/activities': typeof AppActivitiesRoute
  '/appointments': typeof AppAppointmentsRoute
  '/payments': typeof AppPaymentsRoute
  '/services': typeof AppServicesRoute
  '/settings': typeof AppSettingsRoute
  '/': typeof AppIndexRoute
  '/contacts/$contactId': typeof AppContactsContactIdRoute
  '/contacts/new': typeof AppContactsNewRoute
  '/invoices/$invoiceId': typeof AppInvoicesInvoiceIdRoute
  '/contacts': typeof AppContactsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/activities': typeof AppActivitiesRoute
  '/_app/appointments': typeof AppAppointmentsRoute
  '/_app/payments': typeof AppPaymentsRoute
  '/_app/services': typeof AppServicesRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/': typeof AppIndexRoute
  '/_app/contacts/$contactId': typeof AppContactsContactIdRoute
  '/_app/contacts/new': typeof AppContactsNewRoute
  '/_app/invoices/$invoiceId': typeof AppInvoicesInvoiceIdRoute
  '/_app/contacts/': typeof AppContactsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/activities'
    | '/appointments'
    | '/payments'
    | '/services'
    | '/settings'
    | '/contacts/$contactId'
    | '/contacts/new'
    | '/invoices/$invoiceId'
    | '/contacts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/activities'
    | '/appointments'
    | '/payments'
    | '/services'
    | '/settings'
    | '/'
    | '/contacts/$contactId'
    | '/contacts/new'
    | '/invoices/$invoiceId'
    | '/contacts'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/activities'
    | '/_app/appointments'
    | '/_app/payments'
    | '/_app/services'
    | '/_app/settings'
    | '/_app/'
    | '/_app/contacts/$contactId'
    | '/_app/contacts/new'
    | '/_app/invoices/$invoiceId'
    | '/_app/contacts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/activities': {
      id: '/_app/activities'
      path: '/activities'
      fullPath: '/activities'
      preLoaderRoute: typeof AppActivitiesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/appointments': {
      id: '/_app/appointments'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof AppAppointmentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payments': {
      id: '/_app/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof AppPaymentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/services': {
      id: '/_app/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof AppServicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contacts/': {
      id: '/_app/contacts/'
      path: '/contacts'
      fullPath: '/contacts/'
      preLoaderRoute: typeof AppContactsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contacts/$contactId': {
      id: '/_app/contacts/$contactId'
      path: '/contacts/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof AppContactsContactIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contacts/new': {
      id: '/_app/contacts/new'
      path: '/contacts/new'
      fullPath: '/contacts/new'
      preLoaderRoute: typeof AppContactsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/$invoiceId': {
      id: '/_app/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof AppInvoicesInvoiceIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppActivitiesRoute: typeof AppActivitiesRoute
  AppAppointmentsRoute: typeof AppAppointmentsRoute
  AppPaymentsRoute: typeof AppPaymentsRoute
  AppServicesRoute: typeof AppServicesRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppContactsContactIdRoute: typeof AppContactsContactIdRoute
  AppContactsNewRoute: typeof AppContactsNewRoute
  AppInvoicesInvoiceIdRoute: typeof AppInvoicesInvoiceIdRoute
  AppContactsIndexRoute: typeof AppContactsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppActivitiesRoute: AppActivitiesRoute,
  AppAppointmentsRoute: AppAppointmentsRoute,
  AppPaymentsRoute: AppPaymentsRoute,
  AppServicesRoute: AppServicesRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppContactsContactIdRoute: AppContactsContactIdRoute,
  AppContactsNewRoute: AppContactsNewRoute,
  AppInvoicesInvoiceIdRoute: AppInvoicesInvoiceIdRoute,
  AppContactsIndexRoute: AppContactsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
